export default __webpack_public_path__ + "static/media/sv44_kr_head_a1.5dd2af72.mp3";